<template>
  <OfferCard class="ColdOfferCard" @click="$emit('action-forward-click')">
    <OfferCardBrand
      :icon-name="(partner || '').toLowerCase()"
      :artwork="false"
      @click="$emit('brand-click')"
    />
    <OfferCardContent>
      <OfferCardLeading>
        <OfferCardLeadingTitle>
          Até {{ cptdOfferAmount }}
        </OfferCardLeadingTitle>
        <OfferCardLeadingCaption>
          em até {{ maxDuration }}x
        </OfferCardLeadingCaption>
      </OfferCardLeading>
      <OfferCardAction type="ghost" @click="$emit('offer-conditions-click')">
        Continuar simulação
      </OfferCardAction>
    </OfferCardContent>
    <OfferCardBadge>{{ cptdInterestRate }}%</OfferCardBadge>
    <OfferCardActionForward @click="$emit('action-forward-click')" />
  </OfferCard>
</template>

<script>
import { parseToBRL } from '@/helpers/currency'
import OfferCard from '~/aasgard/components/cards/offer-card/OfferCard.vue'
import OfferCardBrand from '~/aasgard/components/cards/offer-card/OfferCardBrand.vue'
import OfferCardContent from '~/aasgard/components/cards/offer-card/OfferCardContent.vue'
import OfferCardLeading from '~/aasgard/components/cards/offer-card/OfferCardLeading.vue'
import OfferCardLeadingTitle from '~/aasgard/components/cards/offer-card/OfferCardLeadingTitle.vue'
import OfferCardLeadingCaption from '~/aasgard/components/cards/offer-card/OfferCardLeadingCaption.vue'
import OfferCardAction from '~/aasgard/components/cards/offer-card/OfferCardAction.vue'
import OfferCardBadge from '~/aasgard/components/cards/offer-card/OfferCardBadge.vue'
import OfferCardActionForward from '~/aasgard/components/cards/offer-card/OfferCardActionForward.vue'

export default {
  name: 'ColdOfferCard',
  components: {
    OfferCardActionForward,
    OfferCardBadge,
    OfferCardAction,
    OfferCardLeadingTitle,
    OfferCardLeading,
    OfferCardContent,
    OfferCardBrand,
    OfferCard,
    OfferCardLeadingCaption,
  },
  props: {
    partner: {
      type: String,
      required: true,
    },
    maxAmount: {
      type: Number,
      required: true,
    },
    maxDuration: {
      type: Number,
      required: true,
    },
    interestRate: {
      type: Number,
      required: true,
    },
  },
  emits: ['action-forward-click', 'brand-click', 'offer-conditions-click'],
  computed: {
    cptdOfferAmount() {
      return parseToBRL(this.maxAmount)
    },
    cptdInterestRate() {
      return (this.interestRate ?? 0)?.toFixed(2)?.replace('.', ',')
    },
  },
  methods: { parseToBRL },
}
</script>

<style lang="scss"></style>
